import React from "react";

import classNames from "classnames";

import DownloadButton from "./DownloadButton";
import SearchBox from "./SearchBox";

import SelectItemsPerPage from "../../../../../../components/SelectItemsPerPage";

const TableFilters = (): React.JSX.Element => {
    return (
        <div className={classNames("filterSubRow")}>
            <SelectItemsPerPage />
            <DownloadButton />
            <SearchBox />
        </div>
    );
};

export default TableFilters;
